"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AssistantProvider", {
  enumerable: true,
  get: function () {
    return _AssistantV.AssistantProvider;
  }
});
Object.defineProperty(exports, "AssistantSidebar", {
  enumerable: true,
  get: function () {
    return _AssistantV.AssistantSidebar;
  }
});
Object.defineProperty(exports, "AssistantStandalone", {
  enumerable: true,
  get: function () {
    return _AssistantV.AssistantStandalone;
  }
});
Object.defineProperty(exports, "BridgeSync", {
  enumerable: true,
  get: function () {
    return _AssistantV.BridgeSync;
  }
});
Object.defineProperty(exports, "useAssistant", {
  enumerable: true,
  get: function () {
    return _AssistantV.useAssistant;
  }
});
var _AssistantV = require("./components/AssistantV2");